import { Box, Button, Checkbox, FormControl, FormLabel, HStack, IconButton, Input, Text } from '@chakra-ui/react';
import { useForm } from "react-hook-form";
import { useDoorData } from '../context/DoorContext';
import { useToast } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { ViewIcon, ViewOffIcon } from '@chakra-ui/icons';

function LoginPage() {
  const toast = useToast()
  const navigate = useNavigate()
  const { register, handleSubmit, formState: { isSubmitting } } = useForm();
  const { client,  user, setUser  } = useDoorData()
  const [showPass, setShowPass] = useState(false);
  const [persist, setPersist] = useState(JSON.parse(localStorage.getItem('persistLogin')) || false);
  const onSubmit = async data => {
    try{
      const res = await client.post("/api/login", {email: data.email, password: data.password})
      setUser(res.data)
      toast({
        title: '👋 Sveiki, ' + res.data.username + '!',
        position: 'bottom',
        status: 'success',
        isClosable: true,
        duration: 4000
      })
    } catch (err) {
      console.log(err.response.data);
      toast({
        title: err.response.data,
        position: 'bottom',
        status: 'error',
        isClosable: true,
        duration: 4000
      })
    }

   


   
  };

  useEffect(() => {
   
    if(user) {
      navigate("/");
      
    }
  }, [user, navigate])

    useEffect(() => {

      localStorage.setItem('persistLogin', persist)

    }, [persist])

  return (
    <Box m={'5rem'} display={'flex'} justifyContent={'center'} flexDirection='column' alignItems={'center'} >
      <Text mb={'2rem'} fontSize={'2xl'}>Praėjimo kontrolė</Text>
      <form onSubmit={handleSubmit(onSubmit)}>
      <FormControl maxW={'30rem'}>
  <FormLabel>El. paštas</FormLabel>
  <Input mb={'1rem'} id='email' {...register("email", { required: true, pattern:/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/i })} name='email' type='text' />
  <FormLabel>Slaptažodis</FormLabel>
  <HStack width={'25rem'}>
  <Input id='password' {...register("password", { minLength: 5, required: true })} name='password' type={showPass ? 'text' : 'password'} />
  
    <IconButton position={'absolute'} right={'-3rem'} backgroundColor='transparent' onClick={() => setShowPass(showPass ? false : true)} icon={showPass ? <ViewOffIcon/> : <ViewIcon/>}></IconButton>
 
  </HStack>
  <Checkbox isChecked={persist} onChange={(e) => setPersist(e.target.checked) } mt={'0.5rem'} w={'100%'} size='md' colorScheme='green' defaultChecked>
    Prisiminti mane?
  </Checkbox>
  <Button mt={'0.5rem'} width={'100%'} colorScheme={'green'} isLoading={isSubmitting} type={'submit'} >Prisijungti</Button>
</FormControl>
    </form>
    </Box>
  )
}

export default LoginPage